import basicController from "servicestack/basic.controller.properties";
import AutoQueryConfig from "servicestack/auto-query/auto-query.config";

export default class AutoQueryNavController {
  constructor() {
    basicController(this);
    let $ctrl = this;
    if ($ctrl.showNavPanel == undefined)
      $ctrl.showNavPanel = AutoQueryConfig.showNavPanel === true;
    if ($ctrl.navTitle == undefined) $ctrl.navTitle = AutoQueryConfig.navTitle;
    if ($ctrl.maxNavHeight == undefined)
      $ctrl.maxNavHeight = AutoQueryConfig.maxNavHeight;
    $ctrl.useTitleCase = AutoQueryConfig.useTitleCase === true;
  }
}
